import { forwardRef } from 'react';

import { IconProps } from '.';

export const GaugeIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M5.5 10C6.05228 10 6.5 10.4477 6.5 11C6.5 11.5523 6.05228 12 5.5 12C4.94772 12 4.5 11.5523 4.5 11C4.5 10.4477 4.94772 10 5.5 10Z"
        fill="currentColor"
      />
      <path
        d="M14.5 10C15.0523 10 15.5 10.4477 15.5 11C15.5 11.5523 15.0523 12 14.5 12C13.9477 12 13.5 11.5523 13.5 11C13.5 10.4477 13.9477 10 14.5 10Z"
        fill="currentColor"
      />
      <path d="M7 7C7.55228 7 8 7.44772 8 8C8 8.55228 7.55228 9 7 9C6.44772 9 6 8.55228 6 8C6 7.44772 6.44772 7 7 7Z" fill="currentColor" />
      <path d="M13 7C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7Z" fill="currentColor" />
      <path
        d="M10 5.5C10.5523 5.5 11 5.94772 11 6.5C11 7.05228 10.5523 7.5 10 7.5C9.44772 7.5 9 7.05228 9 6.5C9 5.94772 9.44772 5.5 10 5.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3C14.4183 3 18 6.58172 18 11C18 12.3766 17.6519 13.6719 17.0391 14.8027L16.9521 14.9473C16.5242 15.6036 15.7666 15.9517 14.9736 15.9951L14.8037 16H12.29C11.9041 16.8826 11.0249 17.5 10 17.5C8.97512 17.5 8.0959 16.8826 7.70996 16H5.19629C4.34303 15.9999 3.50633 15.6504 3.04785 14.9473L2.96094 14.8027C2.34814 13.6719 2 12.3766 2 11C2 6.58172 5.58172 3 10 3ZM10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14ZM10 4.5C6.41015 4.5 3.5 7.41015 3.5 11C3.5 12.1205 3.78322 13.1706 4.28027 14.0879C4.38323 14.2777 4.6764 14.4999 5.19629 14.5H7.5498C7.69273 13.7959 8.13308 13.2014 8.73242 12.8477C8.73468 12.8331 8.73634 12.8183 8.73926 12.8037L9.40234 9.49023C9.45941 9.20522 9.70932 9 10 9C10.2907 9 10.5406 9.20522 10.5977 9.49023L11.2607 12.8037C11.2636 12.8182 11.2643 12.8332 11.2666 12.8477C11.8663 13.2013 12.3072 13.7956 12.4502 14.5H14.8037C15.3236 14.4999 15.6168 14.2777 15.7197 14.0879C16.2168 13.1706 16.5 12.1205 16.5 11C16.5 7.41015 13.5899 4.5 10 4.5Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default GaugeIcon;
